import RoutePaths from "../constants/routepaths";
import RBAC, { ModulesName, userHasModule } from "./roleModuleActions";

/** True when role name matches CMN Specialist (same rule as API dropdown). */
export function isCmnSpecialistUser(user) {
  return !!(user?.roles?.roleList ?? []).some((r) => {
    const rn = (r.roleName || "").trim().toLowerCase();
    return (rn.includes("cmn") && rn.includes("specialist")) || rn.includes("cmnspecialist");
  });
}

/**
 * Default post-login landing route. Module access wins over role defaults so
 * CMN-only users are not sent to Facility / Assessment Queue.
 */
export function resolveDefaultLandingRoute(user) {
  if (!user) return RoutePaths.Page_Facility;

  const cmnSpecialist = isCmnSpecialistUser(user);
  const hasCmnQueue = userHasModule(user, ModulesName.Module_CmnQueue);
  const hasFacilityQueue = userHasModule(user, ModulesName.Module_FacilityQueue);

  if (cmnSpecialist && hasCmnQueue) {
    return RoutePaths.Page_CmnQueue;
  }

  if (hasCmnQueue && !hasFacilityQueue) {
    return RoutePaths.Page_CmnQueue;
  }

  let currentPage = RoutePaths.Page_Facility;
  (user.roles?.roleList ?? []).forEach((role) => {
    if (role.roleName === RBAC.Role_Gentell_Administrator) {
      currentPage = RoutePaths.Page_Facility;
    } else if (role.roleName === RBAC.Role_Gentell_RegionalManager) {
      currentPage = RoutePaths.Page_WorkQueue;
    } else if (role.roleName === RBAC.Role_Gentell_WoundCareSpecialist) {
      currentPage = RoutePaths.Page_WorkQueue;
    } else if (role.roleName === RBAC.Role_Gentell_SeniorBiller) {
      currentPage = RoutePaths.Page_Billing;
    } else if (role.roleName === RBAC.Role_Gentell_IntakeProcessor) {
      currentPage = RoutePaths.Page_Billing;
    } else if (
      role.roleName === RBAC.Role_Facility_Level1 ||
      role.roleName === RBAC.Role_Facility_Level2 ||
      role.roleName === RBAC.Role_Facility_MDSCoordinator
    ) {
      if (hasFacilityQueue) {
        currentPage = RoutePaths.Page_FacilityQueue;
      }
    }
  });

  return currentPage;
}
